module.exports = __webpack_public_path__ + "static/join_international_obj02@2x-920800f0d641b366476dad23e83c97b0.png";